import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import Index2 from '@/components/index/index2'
import Index3 from '@/components/index/index3'
import Index4 from '@/components/index/index4'
import Index5 from '@/components/index/index5'
import Index66 from '@/components/index/index66'
import Articlelist from '@/components/article/articlelist'
import Articledetails from '@/components/article/articledetails'
import Bigshotinfo from '@/components/bigshot/bigshotinfo'
import Bigshotlist from '@/components/bigshot/bigshotlist'
import Allstore from '@/components/bigshot/allstore'
import Storeinfo from '@/components/bigshot/storeinfo'
import IndexPage from '@/components/index2/index6'
import IndexPage2 from '@/components/index2/index7'
import IndexPage3 from '@/components/index2/index8'
import IndexPage4 from '@/components/index2/index9'
import IndexPage5 from '@/components/index2/index10'
import BigshotInfo from '@/components/bigshot2/bigshotinfo2'
import BigshotList from '@/components/bigshot2/bigshotlist2'
import AllStore from '@/components/bigshot2/allstore2'
import StoreInfo from '@/components/bigshot2/storeinfo2'
import ArticleDetails from '@/components/bigshot2/articledetails2'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/index2',
      name: 'index2',
      component: Index2
    },
    {
      path: '/index3',
      name: 'index3',
      component: Index3
    },
    {
      path: '/index4',
      name: 'index4',
      component: Index4
    },
    {
      path: '/index5',
      name: 'index5',
      component: Index5
    },
    {
      path: '/index66',
      name: 'index66',
      redirect: '/index6',
      component: Index66
    },
    {
      path: '/articlelist',
      name: 'articlelist',
      component: Articlelist
    },
    {
      path: '/articledetails',
      name: 'articledetails',
      component: Articledetails
    },
    {
      path: '/bigshotinfo',
      name: 'bigshotinfo',
      component: Bigshotinfo
    },
    {
      path: '/bigshotlist',
      name: 'bigshotlist',
      component: Bigshotlist
    },
    {
      path: '/allstore',
      name: 'allstore',
      component: Allstore
    },
    {
      path: '/storeinfo',
      name: 'storeinfo',
      component: Storeinfo
    },
    {
      path: '/index6',
      name: 'index6',
      component: IndexPage,
      meta:{
          keepAlive:true
      }
  },
  {
      path: '/index7',
      name: 'index7',
      component: IndexPage2,
      meta:{
          keepAlive:true
      }
  },
  {
      path: '/index8',
      name: 'index8',
      component: IndexPage3,
      meta:{
          keepAlive:true
      }
  },
  {
      path: '/index9',
      name: 'index9',
      component: IndexPage4,
      meta:{
          keepAlive:true
      }
  },
  {
      path: '/index10',
      name: 'index10',
      component: IndexPage5,
      meta:{
          keepAlive:true
      }
  },
  {
      path: '/bigshotinfo2',
      name: 'bigshotinfo2',
      component: BigshotInfo
  },
  {
      path: '/bigshotlist2',
      name: 'bigshotlist2',
      component: BigshotList
  },
  {
      path: '/allstore2',
      name: 'allstore2',
      component: AllStore
  },
  {
      path: '/storeinfo2',
      name: 'storeinfo2',
      component: StoreInfo
  },
  {
      path: '/articledetails2',
      name: 'articledetails2',
      component: ArticleDetails
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js